import { render, staticRenderFns } from "./box-content.vue?vue&type=template&id=6e2b7c50"
import script from "./box-content.vue?vue&type=script&lang=js"
export * from "./box-content.vue?vue&type=script&lang=js"
import style0 from "./box-content.vue?vue&type=style&index=0&id=6e2b7c50&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports